import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface PlayPauseFlashMessageRequest extends APIRequest
{
    getMsisdn(): string;
    getStatus(): string;
}

export class PlayPauseFlashMessageRequestImpl extends APIRequestDtoImpl implements PlayPauseFlashMessageRequest
{
    constructor(private msisdn: string, private status: string)
    {
        super();
    }
    getStatus(): string {
       return this.status;
    }
    getMsisdn(): string {
       return this.msisdn;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/flashmessage/playpause/playpauseflashmessagesrequest.tsx